import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import ar from './locales/ar.json';
import en from './locales/en.json';

import { env } from '@/lib/env';

export const supportedLocales = ['ar', 'en'] as const;
export type SupportedLocale = (typeof supportedLocales)[number];

export async function initI18n(): Promise<typeof i18n> {
  await i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        ar: { translation: ar },
        en: { translation: en },
      },
      fallbackLng: env.VITE_DEFAULT_LOCALE,
      supportedLngs: [...supportedLocales],
      interpolation: { escapeValue: false },
      detection: {
        order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
        caches: ['localStorage'],
      },
    });
  return i18n;
}

export function applyLocaleDirection(locale: string): void {
  const dir = locale === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', locale);
}

export default i18n;
